import { Map } from 'immutable';
import defaultDialogReducer from '../../defaultDialogReducer';
import { dialogsNames } from '../../../enums/dialogsNames';
import { actionTypes as actionTypes } from '../../../actions/Administration/SettingsPage/Dialogs/createTrucksSensorConfigDialogActions';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: null,
  eventProfiles: Map(),
};

export default function (state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.CREATE_TRUCKS_SENSOR_CONFIGURATION_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show', true);

    case actionTypes.CREATE_TRUCKS_SENSOR_CONFIGURATION_DIALOG_FETCH_EVENT_PROFILES_READY:
      return state.set('loading', false).set('eventProfiles', action.payload);

    default:
      return defaultDialogReducer(state, action, dialogsNames.CREATE_TRUCKS_SENSOR_CONFIGURATION_DIALOG, defaultState);
  }
}
